export enum VoicemailAnalyticsEvents {
  SearchTermChanged = 'search_term_chngd',
  ExtensionFilterChanged = 'ext_fltr_chngd',
  UnreadFilterChanged = 'unrd_fltr_chngd',
  LinkCopied = 'link_copied',
  LinkCopiedAtTimestamp = 'link_copied_tmstmp',
  ExternalVoicemailLink = 'extern_vm_link',
  VoicemailDeleted = 'vm_dlt',
  VoicemailMarkedAsUnread = 'vm_unrd',
  VoicemailSelected = 'vm_slctd',
  VoicemailNotFound = 'vm_nf',
  VoicemailLoadError = 'vm_load_err',
}
